import {
	OrderFieldTypeEnum,
	OrderSetupStatusEnum,
} from "Infrastructure/Api/Api";
import { Resources } from "Infrastructure/Translation/Resources";
import type { TOptions } from "i18next";
import type { ObjPathProxy } from "ts-object-path";
import { z } from "zod";

const validationMessagesResource = Resources.base.orderSetup.validationMessages;

const OrderCreateFieldSchema = z
	.object({
		key: z
			.string()
			.nonempty()
			.refine(
				(value) => !/[^a-z_]/g.test(value ?? ""),
				"This key contains forbidden characters",
			),
		label: z.string().nonempty(),
		type: z.nativeEnum(OrderFieldTypeEnum),
		value: z.string().nullable().optional(),
		orderIndex: z.number().int(),
		emailLabel: z.string().default(""),
		isEmailIncluded: z.boolean().default(true),
	})
	.refine(
		(data) => {
			if (data.type === OrderFieldTypeEnum.enum) {
				return !!data.value;
			}
			return true;
		},
		{
			message: "Value is required when type is enum",
			path: ["value"],
		},
	);

export const getOrderSetupEditFormSchema = (
	t: (
		resourcePath: ObjPathProxy<unknown, string>,
		options?: TOptions,
	) => string,
) => {
	return z.object({
		name: z.string().nullish(),
		status: z.nativeEnum(OrderSetupStatusEnum).nullish(),
		orderFields: z.array(OrderCreateFieldSchema).nonempty({
			message: `${t(validationMessagesResource.orderFieldsNonEmpty)}`,
		}),
	});
};

export type OrderSetupEditFormModel = z.infer<
	ReturnType<typeof getOrderSetupEditFormSchema>
>;
